import TileRecordView from "../Tiles/Tile/TileRecordView"
import DummyRecordView from "web/components/RecordView/DummyRecordView"
import { isNotAValue } from "web/services/helpers"

const MESSAGE_DIV_CLASSES =
  "flex h-full items-center justify-center px-10 py-0 text-center italic text-neutral-7"

// Functions as a wrapper for passing a list into RecordView.
// Only shows the first object and has a message when empty
export default function RecordViewList({
  data,
  emptyMessage,
  showDummyData,
  fields,
  isDoubleColumn,
  ...rest
}) {
  const recordCount = data.length

  if (!showDummyData && recordCount === 0) {
    return <div className={MESSAGE_DIV_CLASSES}>{emptyMessage}</div>
  }

  if (fields.length === 0) {
    return (
      <div className={MESSAGE_DIV_CLASSES}>
        There are no fields selected for this tile.
      </div>
    )
  }

  function fieldsHaveValues() {
    return fields.some(
      (field) => data[0].values && !isNotAValue(data[0].values[field.key])
    )
  }

  const hasNoFieldsToDisplay =
    !showDummyData &&
    recordCount > 0 &&
    fields.length > 0 &&
    !fieldsHaveValues()

  if (hasNoFieldsToDisplay) {
    return (
      <div className={MESSAGE_DIV_CLASSES}>
        There are no fields with values selected for this tile.
      </div>
    )
  }

  if (showDummyData) {
    return (
      <DummyRecordView
        fields={fields}
        isDoubleColumn={isDoubleColumn}
        {...rest}
      />
    )
  } else {
    return (
      <TileRecordView
        data={data[0]}
        fields={fields}
        isDoubleColumn={isDoubleColumn}
        {...rest}
      />
    )
  }
}
